import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

interface modelDisplay {
  model_name: string;
  model: string;
  mode: string;
}

interface modelMap {
  name: string;
  icon: any;
}

// ✅ Updated slice state
interface modelState {
  model: string;
  models: { [index: string]: modelDisplay[] };
  imagemodel: string;
  modelmaps: { [index: string]: modelMap };
  semanticEnabled: boolean; // ✅ NEW
}

// ✅ Updated initial state
const initialState: modelState = {
  model: "",
  models: {
    chat: [],
    image: [],
    multimodel: [],
    embeddings: [],
  },
  imagemodel: "",
  modelmaps: {},
  semanticEnabled: false, // ✅ NEW
};

export const modelSlice = createSlice({
  name: "model",
  initialState,
  reducers: {
    addModel: (state, action) => {
      return {
        ...state,
        model: action.payload,
        semantic: false, // ✅ reset semantic when model selected
      };
    },
    addModelsForKey: (state, action) => {
      return {
        ...state,
        models: action.payload,
      };
    },
    addImageModels: (state, action) => {
      return {
        ...state,
        imagemodel: action.payload,
        semantic: false, // ✅ reset semantic when image model selected
      };
    },
    addModelMappings: (state, action) => {
      return {
        ...state,
        modelmaps: action.payload,
      };
    },
    // ✅ NEW reducer
    setSemanticEnabled: (state, action) => {
      return {
        ...state,
        semanticEnabled: action.payload,
      };
    },
  },
});

export const {
  addModel,
  addModelsForKey,
  addImageModels,
  addModelMappings,
  setSemanticEnabled,
} = modelSlice.actions;

export const getModelDetails = (state: RootState) => state.model;

export default modelSlice.reducer;
